/** @jsxImportSource @emotion/react */
import { Box, Typography, useTheme } from '@mui/material'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { QuickLinks } from '@app/components/Guide/ui/QuickLinks'
import { SplashPage } from '@app/components/ui/SplashPage/SplashPage'
import { SplashBanner } from '@app/components/ui/SplashPage/SplashPageBanner'
import { appLink } from '@app/config/appLink'
import { riskButtonWrapper, riskSearchContainer, riskSearchTitle } from './RiskLandingPage.style'
import { useNavigate } from 'react-router-dom'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'
import { FEATURE_FLAGS } from '@app/app-constants'

const bannerImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_risk_hero.svg`
const logoImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_risk_logo.svg`

export const RiskLandingPage = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { useFeatureFlag } = useFeatureFlags()
  const isPrioritisationEnabled = useFeatureFlag(FEATURE_FLAGS.PRIORITISATION_PAGE)
  const isSummaryEnabled = useFeatureFlag(FEATURE_FLAGS.SUMMARY_PAGE)
  const links = [
    {
      label: 'Explore the risk to an element or portfolio',
      onClick: () => navigate(`${appLink.risk.path}/explorer`),
    },
  ]

  if (isSummaryEnabled)
    links.push({
      label: 'Export asset risk by element group and by region',
      onClick: () => navigate(`${appLink.risk.path}/summary`),
    })

  if (isPrioritisationEnabled)
    links.push({
      label: 'Prioritise adaptation areas',
      onClick: () => navigate(`${appLink.risk.path}/prioritisation`),
    })

  links.push({
    label: 'See my organisation’s risk stories',
    onClick: () => navigate(`${appLink.risk.path}/stories`),
  })

  return (
    <SplashPage>
      <SplashPage.Hero>
        <SplashBanner testId="risk-splash-page-banner">
          <SplashBanner.Wrapper>
            <SplashBanner.LeftColumn>
              <SplashBanner.Logo src={logoImg} alt="Risk - Resilience Explorer" />
              <SplashBanner.Headline>
                Explore the risk to an individual element or portfolio of elements.{' '}
              </SplashBanner.Headline>
            </SplashBanner.LeftColumn>
            <SplashBanner.RightColumn>
              <SplashBanner.Image src={bannerImg} alt="Risk - Overview Image" />
            </SplashBanner.RightColumn>
          </SplashBanner.Wrapper>
        </SplashBanner>
      </SplashPage.Hero>
      <SplashPage.Content>
        <Box css={riskSearchContainer}>
          <Typography css={riskSearchTitle} variant="h4" component="h4">
            I want to...
          </Typography>
          <Box css={() => riskButtonWrapper({ theme })}>
            <QuickLinks theme={theme} links={links} />
          </Box>
        </Box>
      </SplashPage.Content>
    </SplashPage>
  )
}
